(function () {

  var styles = `
    #caxes-story-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.80);
      z-index: 99999;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }
    #caxes-story-overlay.active { display: flex; }
    #caxes-story-box {
      background: #111;
      color: #fff;
      border: 2px solid #e6ff00;
      border-radius: 16px;
      max-width: 500px;
      width: 100%;
      padding: 36px 28px;
      box-shadow: 0 0 40px rgba(230,255,0,0.15);
      position: relative;
      text-align: center;
      font-family: inherit;
    }
    #caxes-story-box h2 {
      font-size: 1.6rem;
      margin: 0 0 10px;
      color: #e6ff00;
      line-height: 1.3;
    }
    #caxes-story-box p {
      font-size: 1.1rem;
      color: #ccc;
      margin: 0 0 24px;
      line-height: 1.6;
    }
    .caxes-btn {
      display: inline-block;
      padding: 15px 28px;
      border-radius: 50px;
      font-size: 1.1rem;
      font-weight: 700;
      cursor: pointer;
      border: none;
      transition: transform 0.15s, opacity 0.15s;
      width: 100%;
      margin-bottom: 12px;
    }
    .caxes-btn:hover { opacity: 0.88; transform: scale(1.02); }
    .caxes-btn-yes { background: #e6ff00; color: #000; }
    .caxes-btn-no { background: transparent; color: #aaa; border: 1px solid #444; font-size: 1rem; padding: 11px 20px; }
    .caxes-step { display: none; }
    .caxes-step.active { display: block; }
    .caxes-photo-btns { display: flex; gap: 12px; margin-bottom: 16px; }
    .caxes-photo-btns .caxes-btn { margin-bottom: 0; font-size: 0.95rem; }
    .caxes-input {
      width: 100%;
      background: #1a1a1a;
      border: 1px solid #333;
      border-radius: 8px;
      color: #fff;
      padding: 12px 14px;
      font-size: 1rem;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
    .caxes-input:focus { outline: 1px solid #e6ff00; border-color: #e6ff00; }
    .caxes-input::placeholder { color: #555; }
    .caxes-label {
      font-size: 0.95rem;
      color: #888;
      text-align: left;
      display: block;
      margin: 8px 0 4px;
    }
    .caxes-info-box {
      background: #1a1a1a;
      border: 1px solid #333;
      border-radius: 8px;
      padding: 16px;
      font-size: 1rem;
      color: #aaa;
      margin-top: 14px;
      text-align: left;
      line-height: 1.7;
    }
    .caxes-close {
      position: absolute;
      top: 12px; right: 16px;
      background: none;
      border: none;
      color: #666;
      font-size: 1.5rem;
      cursor: pointer;
      line-height: 1;
    }
    .caxes-close:hover { color: #fff; }
    .caxes-emoji { font-size: 2.2rem; margin-bottom: 10px; }
    .caxes-yellow { color: #e6ff00; font-weight: 700; }
  `;

  function injectStyles() {
    if (document.getElementById('caxes-styles')) return;
    var s = document.createElement('style');
    s.id = 'caxes-styles';
    s.textContent = styles;
    document.head.appendChild(s);
  }

  var photoChoice = null;
  var checkoutHref = null;

  function buildPopup() {
    if (document.getElementById('caxes-story-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'caxes-story-overlay';
    overlay.innerHTML = `
      <div id="caxes-story-box">
        <button class="caxes-close" id="caxes-close">&times;</button>

        <!-- STEP 1 -->
        <div class="caxes-step active" id="caxes-s1">
          <div class="caxes-emoji">📸</div>
          <h2>Tu veux apparaître dans nos stories ?</h2>
          <p>On adore mettre nos clients à l'honneur sur nos réseaux ! C'est 100% sur la base du volontariat 🤘</p>
          <button class="caxes-btn caxes-btn-yes" id="caxes-oui">Oui, je veux être dans votre story ! 🤙</button>
          <button class="caxes-btn caxes-btn-no" id="caxes-non">Non merci, je préfère rester discret</button>
        </div>

        <!-- STEP 2 -->
        <div class="caxes-step" id="caxes-s2">
          <div class="caxes-emoji">🤔</div>
          <h2>Comment on fait pour la photo ?</h2>
          <p>À toi de choisir :</p>
          <div class="caxes-photo-btns">
            <button class="caxes-btn caxes-btn-yes" id="caxes-photo-me">📤 J'envoie ma propre photo<br><small style="font-weight:400;opacity:0.6">(avec ou sans visage, c'est toi qui choisis !)</small></button>
            <button class="caxes-btn caxes-btn-yes" id="caxes-photo-vous" style="background:#1a1a1a;color:#e6ff00;border:2px solid #e6ff00;">📦 Vous la faites vous-mêmes<br><small style="font-weight:400;opacity:0.6">(photo du t-shirt de notre côté)</small></button>
          </div>
          <button class="caxes-btn caxes-btn-no" id="caxes-back1">← Retour</button>
        </div>

        <!-- STEP 3 -->
        <div class="caxes-step" id="caxes-s3">
          <div class="caxes-emoji">🔗</div>
          <h2>Tes réseaux sociaux</h2>
          <p>Pour qu'on puisse te taguer ! Laisse vide si tu ne veux pas être tagué·e.</p>
          <span class="caxes-label">📷 Instagram</span>
          <input class="caxes-input" id="caxes-insta" type="text" placeholder="@tonpseudo" />
          <span class="caxes-label">🎵 TikTok</span>
          <input class="caxes-input" id="caxes-tiktok" type="text" placeholder="@tonpseudo" />
          <span class="caxes-label">👤 Facebook</span>
          <input class="caxes-input" id="caxes-fb" type="text" placeholder="Ton nom ou pseudo Facebook" />
          <button class="caxes-btn caxes-btn-yes" id="caxes-next3" style="margin-top:8px;">Continuer →</button>
          <button class="caxes-btn caxes-btn-no" id="caxes-back2">← Retour</button>
        </div>

        <!-- STEP 4 -->
        <div class="caxes-step" id="caxes-s4">
          <div class="caxes-emoji">✍️</div>
          <h2>Un message pour la story ?</h2>
          <p>Une phrase, un hashtag, un cri du cœur ? C'est le moment ! (totalement optionnel)</p>
          <textarea class="caxes-input" id="caxes-msg" rows="3" placeholder="Ex : Fier d'être un Caxé ! 🏍️"></textarea>
          <button class="caxes-btn caxes-btn-yes" id="caxes-finish">C'est parti ! 🚀</button>
          <button class="caxes-btn caxes-btn-no" id="caxes-back3">← Retour</button>
        </div>

        <!-- STEP 5 : Merci -->
        <div class="caxes-step" id="caxes-s5">
          <div class="caxes-emoji">🙌</div>
          <h2>Merci, t'es au top !</h2>
          <p id="caxes-merci-txt"></p>
          <div class="caxes-info-box" id="caxes-photo-info"></div>
          <button class="caxes-btn caxes-btn-yes" id="caxes-go-checkout" style="margin-top:20px;">Finaliser ma commande →</button>
        </div>

      </div>
    `;
    document.body.appendChild(overlay);
    bindEvents(overlay);
  }

  function goStep(n) {
    document.querySelectorAll('.caxes-step').forEach(function(el) { el.classList.remove('active'); });
    document.getElementById('caxes-s' + n).classList.add('active');
  }

  function bindEvents(overlay) {
    document.getElementById('caxes-close').addEventListener('click', closeAndCheckout);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeAndCheckout(); });
    document.getElementById('caxes-oui').addEventListener('click', function() { goStep(2); });
    document.getElementById('caxes-non').addEventListener('click', closeAndCheckout);
    document.getElementById('caxes-photo-me').addEventListener('click', function() { photoChoice = 'me'; goStep(3); });
    document.getElementById('caxes-photo-vous').addEventListener('click', function() { photoChoice = 'vous'; goStep(3); });
    document.getElementById('caxes-back1').addEventListener('click', function() { goStep(1); });
    document.getElementById('caxes-next3').addEventListener('click', function() { goStep(4); });
    document.getElementById('caxes-back2').addEventListener('click', function() { goStep(2); });
    document.getElementById('caxes-finish').addEventListener('click', function() { saveToCart(); buildMerci(); goStep(5); });
    document.getElementById('caxes-back3').addEventListener('click', function() { goStep(3); });
    document.getElementById('caxes-go-checkout').addEventListener('click', closeAndCheckout);
  }

  function buildMerci() {
    var insta = document.getElementById('caxes-insta').value.trim();
    var tiktok = document.getElementById('caxes-tiktok').value.trim();
    var fb = document.getElementById('caxes-fb').value.trim();
    var tags = [insta, tiktok, fb].filter(Boolean).join(', ');

    document.getElementById('caxes-merci-txt').innerHTML = tags
      ? 'On te tagguera sur <strong>' + tags + '</strong> 🤙'
      : 'On a bien reçu ta demande, on s\'occupe de tout !';

    var info = document.getElementById('caxes-photo-info');
    if (photoChoice === 'me') {
      info.innerHTML = '📤 <strong>Envoie ta photo</strong> (avec ou sans visage, c\'est toi qui choisis) à :<br><br><span class="caxes-yellow">lescaxes@gmail.com</span><br><small style="color:#666">Objet : Story + ton prénom/pseudo</small><br><br>Tu peux aussi y ajouter un message si tu veux 😊';
    } else {
      info.innerHTML = '📦 Pas de stress, on s\'occupe de la photo du t-shirt de notre côté. On te tagguera dès que c\'est posté ! 🔥';
    }
  }

  function saveToCart() {
    var insta = document.getElementById('caxes-insta').value.trim();
    var tiktok = document.getElementById('caxes-tiktok').value.trim();
    var fb = document.getElementById('caxes-fb').value.trim();
    var msg = document.getElementById('caxes-msg').value.trim();
    var photo = photoChoice === 'me' ? 'Client envoie sa photo' : 'On fait la photo nous-mêmes';

    var reseaux = [
      insta ? 'Instagram: ' + insta : '',
      tiktok ? 'TikTok: ' + tiktok : '',
      fb ? 'Facebook: ' + fb : ''
    ].filter(Boolean).join(' | ');

    // Sauvegarde dans les attributs du panier (visible dans chaque commande Shopify)
    var attributes = {
      'Story OK': 'Oui',
      'Story Photo': photo,
      'Story Réseaux': reseaux || '–',
      'Story Message': msg || '–'
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function(){});

    // Email de notification en parallèle
    var body = '📸 DEMANDE STORY – LES CAXÉS\n';
    body += '================================\n';
    body += 'Photo : ' + photo + '\n';
    body += 'Instagram : ' + (insta || '–') + '\n';
    body += 'TikTok : ' + (tiktok || '–') + '\n';
    body += 'Facebook : ' + (fb || '–') + '\n';
    body += 'Message : ' + (msg || '–') + '\n';

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', 'lescaxes@gmail.com');
    fd.append('contact[name]', 'Story Popup – commande client');
    fd.append('contact[body]', body);
    fetch('/contact', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(function(){});
  }

  function openPopup(url) {
    checkoutHref = url || '/checkout';
    document.getElementById('caxes-story-overlay').classList.add('active');
    goStep(1);
    photoChoice = null;
  }

  function closeAndCheckout() {
    document.getElementById('caxes-story-overlay').classList.remove('active');
    window.location.href = checkoutHref || '/checkout';
  }

  function interceptCheckout() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('a[href="/checkout"], button[name="checkout"], .cart__checkout-button, [href*="/checkout"]');
      if (!btn) return;
      if (!document.getElementById('caxes-story-overlay')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openPopup(btn.href || '/checkout');
    }, true);
  }

  function init() {
    injectStyles();
    buildPopup();
    interceptCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();